import { QColorPicker } from "../CoreApp/QColorPicker";

export function TPPostColorPicker(
  wsMgr,
  parent,
  x,
  y,
  baseCmd,
  enableNoFill,
  enableCustom,
  startColor,
  startColor2,
  fillMode,
  advMode,
  idx,
  mode,
  aCmd,
  subCodeList = []
) {
  var colorPicker = new QColorPicker();
  colorPicker["parent"] = parent;
  if (idx) colorPicker["colorIdx"] = idx;
  var w = wsMgr;
  var backGroundPanel = w.GetBackgroundPanel();

  var adj = colorPicker.AdjustPlacement(
    x,
    y,
    colorPicker.GetPickerWidth(),
    colorPicker.GetPickerHeight(),
    backGroundPanel
  );
  colorPicker.PositionPanel(adj.fX, adj.fY);

  var oi = w.GetOrgInfo();
  var customColors = null;
  if (enableCustom == true)
    // Not sure if this works - always true...
    customColors = oi.GetCustomColors();

  colorPicker.InitColorPicker(
    wsMgr,
    baseCmd,
    startColor,
    startColor2,
    fillMode,
    enableNoFill,
    customColors,
    advMode,
    enableCustom
  );
  colorPicker.fSubCodeList = subCodeList;
  if (mode) colorPicker.SetReturn(parent);
  w.PushPanel(colorPicker);
  if (aCmd) colorPicker.SmartPositionPanel(aCmd.GetSourceElement());
  return colorPicker;
}
